<template>
  <v-sheet :color="color" class="plannings-task-block-day" tile>
    <p class="plannings-task-block-day__title text-subtitle-1">
      {{ reason }}
    </p>
    <p class="plannings-task-block-day__item">
      {{ time }}
    </p>
    <p class="plannings-task-block-day__item">
      <strong>{{ $t('ITEM.ADDITIONAL_INFO') }}:</strong>
      {{ task.info }}
    </p>
    <div class="plannings-task-block-day__buttons">
      <slot name="buttons">
        <v-btn color="white" depressed small @click="view">
          {{ $t('BUTTON.VIEW') }}
        </v-btn>
      </slot>
    </div>
  </v-sheet>
</template>

<script>
import task from './mixins/task';

export default {
  name: 'BlockDayTask',

  mixins: [task],

  computed: {
    reason() {
      return (this.task.reason && this.task.reason.name) || '';
    }
  }
};
</script>

<style lang="scss">
.plannings-task-block-day {
  & &__title {
    text-align: center;
  }

  & &__item {
    display: block;
    margin-bottom: 0.5em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & &__buttons {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
